import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "blue_box _full" }
const _hoisted_3 = {
  class: "sch_condition_wrap",
  style: {"margin-top":"5px"}
}
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "select_tab_box_wrap" }
const _hoisted_6 = { class: "select_tab_box _130" }
const _hoisted_7 = { class: "tab_option" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "select_tab_box_wrap" }
const _hoisted_10 = { class: "select_date_wrap" }
const _hoisted_11 = { class: "select_date" }
const _hoisted_12 = { class: "select_date" }
const _hoisted_13 = {
  class: "search_wrap",
  style: {"width":"400px","margin-left":"10px"}
}
const _hoisted_14 = { class: "right" }
const _hoisted_15 = { type: "button" }
const _hoisted_16 = { class: "common_table custom_scroll" }
const _hoisted_17 = { class: "list_num cnt" }
const _hoisted_18 = { class: "cnt" }
const _hoisted_19 = { class: "cnt" }
const _hoisted_20 = { class: "cnt" }
const _hoisted_21 = { class: "cnt" }
const _hoisted_22 = { class: "cnt" }
const _hoisted_23 = { class: "cnt" }
const _hoisted_24 = { class: "cnt" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "cnt" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "cnt" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ActionGroupModal = _resolveComponent("ActionGroupModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "box_tit _flex" }, [
          _createElementVNode("h2", null, "액션 시민 그룹")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "sch_list_tit" }, "상태값", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["selected_tab", [$setup.state.isShowSearchType ? 'active' : '']]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.state.isShowSearchType = !$setup.state.isShowSearchType))
                }, [
                  _createElementVNode("span", null, _toDisplayString($setup.search.searchType.name), 1)
                ], 2),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectOption, (item) => {
                    return (_openBlock(), _createElementBlock("button", {
                      onClick: ($event: any) => {
                                        $setup.search.searchType = item;
                                        $setup.state.isShowSearchType = false;
                                        $setup.getList();
                                    }
                    }, _toDisplayString(item.name), 9, _hoisted_8))
                  }), 256))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sch_list_tit" }, "활동 기간", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.search.startDate) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.search.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    style: {"margin-left":"5px"},
                    type: "date",
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchDate && $setup.searchDate(...args)), ["enter"])),
                    name: "",
                    id: "",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.search.endDate) = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.search.endDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.search.keyword) = $event)),
                    onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => ($setup.getList()), ["enter"])),
                    placeholder: "제목을 입력하세요."
                  }, null, 544), [
                    [_vModelText, $setup.search.keyword]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "search_btn icon_wrap",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.getList()))
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("img", {
                      src: "img/search_btn.png",
                      alt: ""
                    }, null, -1)
                  ]))])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              class: "default_btn _blue",
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.isShowActionModal = true))
            }, "등록"),
            _createElementVNode("button", _hoisted_15, [
              _createElementVNode("img", {
                src: "img/excel_icon.png",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.excelDownload && $setup.excelDownload(...args))),
                alt: " 엑셀 다운로드"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", null, [
            _cache[18] || (_cache[18] = _createElementVNode("colgroup", null, [
              _createElementVNode("col", { style: {"width":"80px"} }),
              _createElementVNode("col"),
              _createElementVNode("col", { style: {"width":"160px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"90px"} }),
              _createElementVNode("col", { style: {"width":"90px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"100px"} }),
              _createElementVNode("col", { style: {"width":"80px"} })
            ], -1)),
            _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "번호"),
                _createElementVNode("th", null, "제목"),
                _createElementVNode("th", null, "활동 기간"),
                _createElementVNode("th", null, "등록일"),
                _createElementVNode("th", null, "출석 회차"),
                _createElementVNode("th", null, "액션활동 주차"),
                _createElementVNode("th", null, "모집인원"),
                _createElementVNode("th", null, "평균 참여 인원"),
                _createElementVNode("th", null, "상태"),
                _createElementVNode("th", null, "액션활동관리"),
                _createElementVNode("th", null, "상세")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              ($setup.state.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.idx
                    }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(($setup.state.currentPage - 1) * $setup.state.perPage + (idx + 1)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.title), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(new Date(item.startDate))) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(new Date(item.endDate))), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(new Date(item.createDate))), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.cntRound), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(item.cntState), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.cntCitizen), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(item.avgCntEntireForRound), 1),
                      _createElementVNode("td", _hoisted_24, [
                        (item.state === 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "default_btn _blue",
                              onClick: ($event: any) => ($setup.stateChange(item))
                            }, "진행중", 8, _hoisted_25))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "default_btn _gray",
                              onClick: ($event: any) => ($setup.stateChange(item))
                            }, "종료", 8, _hoisted_26))
                      ]),
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("button", {
                          class: "default_btn _blue",
                          onClick: ($event: any) => ($setup.router.push(`/action/${item.idx}/state`))
                        }, "관리", 8, _hoisted_28)
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("button", {
                          class: "default_btn _blue",
                          onClick: ($event: any) => ($setup.router.push(`/action/group/${item.idx}`))
                        }, "상세", 8, _hoisted_30)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_31, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("td", { colspan: "11" }, [
                      _createElementVNode("div", {
                        class: "tb_subject",
                        style: {"text-align":"center","width":"100%"}
                      }, "데이터가 없습니다.")
                    ], -1)
                  ]))]))
            ])
          ])
        ]),
        _createVNode(_component_PageBtn, {
          currentPage: $setup.state.currentPage,
          totalLength: $setup.state.totalLength,
          perPage: $setup.state.perPage,
          onOnPaging: $setup.handlePageChange
        }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.modal.tab,
          title: $setup.modal.title,
          content: $setup.modal.content,
          onClose: _cache[12] || (_cache[12] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowActionModal)
      ? (_openBlock(), _createBlock(_component_ActionGroupModal, {
          key: 1,
          onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.isShowActionModal = false)),
          onCallback: $setup.closeActionModal
        }, null, 8, ["onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}